(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents, currency) => new Intl.NumberFormat('en-PK', {style:'currency', currency, maximumFractionDigits:0}).format(cents / 100);
  const quantity = form => Number(form.querySelector('[name="quantity"]')?.value || 1);
  function update(card) {
    const form = card.closest('form');
    const selected = card.querySelector('[data-matching-toggle]').checked;
    const qty = Math.max(1, Math.floor(quantity(form) || 1));
    const original = Number(card.dataset.primaryPrice) + (selected ? Number(card.dataset.matchingPrice) : 0);
    const total = (original - (selected ? Number(card.dataset.saving) : 0)) * qty;
    card.querySelector('[data-matching-total]').textContent = money(total, card.dataset.currency);
    const crossed = card.querySelector('[data-matching-original]');
    crossed.hidden = !selected;
    crossed.textContent = money(original * qty, card.dataset.currency);
    card.querySelector('[data-matching-note]').hidden = !selected;
    form.querySelector('[data-matching-buy]').hidden = !selected;
    const main = form.querySelector('.ProductForm__AddToCart');
    if (main && !form.dataset.matchingBusy) {
      main.innerHTML = selected ? `${card.dataset.addSet} — ${money(total, card.dataset.currency)}` : card.dataset.originalButton;
    }
  }
  function init() {
    document.querySelectorAll('[data-monzoro-matching]').forEach(card => {
      if (card.dataset.ready) return;
      const form = card.closest('form');
      const buy = card.querySelector('[data-matching-buy]');
      form.querySelector('.ProductForm__AddToCart')?.insertAdjacentElement('afterend', buy);
      card.dataset.originalButton = form.querySelector('.ProductForm__AddToCart')?.innerHTML || '';
      card.dataset.ready = 'true';
      card.hidden = false;
      update(card);
    });
  }
  async function addSet(form, card, checkout) {
    if (form.dataset.matchingBusy) return;
    const error = card.querySelector('[data-matching-error]');
    const review = card.querySelector('[data-matching-review]');
    const qty = quantity(form);
    if (!Number.isSafeInteger(qty) || qty < 1) {
      error.textContent = card.dataset.quantityError;
      error.hidden = false;
      return;
    }
    const primaryId = Number(new FormData(form).get('id'));
    const matchingId = Number(card.dataset.matchingVariant);
    if (!primaryId || !matchingId) return;
    form.dataset.matchingBusy = 'true';
    error.hidden = true;
    review.hidden = true;
    const buttons = [...form.querySelectorAll('button[type="submit"], [data-matching-buy]')];
    const states = buttons.map(b => ({button:b, disabled:b.disabled, html:b.innerHTML}));
    buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    const main = form.querySelector('.ProductForm__AddToCart');
    if (main) main.textContent = card.dataset.adding;
    try {
      const discountCode = card.dataset.matchingDiscountCode || '';
      let discountCodes = [];
      if (discountCode) {
        const cartResponse = await fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store'});
        if (!cartResponse.ok) throw new Error('Unable to check existing discounts');
        const currentCart = await cartResponse.json();
        discountCodes = (currentCart.discount_codes || []).map(discount => discount.code).filter(Boolean);
        if (!discountCodes.some(code => code.toUpperCase() === discountCode.toUpperCase())) discountCodes.push(discountCode);
      }
      const response = await fetch(root + 'cart/add.js', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({items:[{id:primaryId,quantity:qty},{id:matchingId,quantity:qty}]})
      });
      const result = await response.json();
      if (!response.ok || !Array.isArray(result.items) || result.items.length !== 2) throw new Error('Incomplete set');
      if (discountCode) {
        const discountResponse = await fetch(root + 'cart/update.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({discount:discountCodes.join(',')})
        });
        const discountedCart = await discountResponse.json();
        const applied = (discountedCart.discount_codes || []).some(discount => discount.code.toUpperCase() === discountCode.toUpperCase() && discount.applicable);
        if (!discountResponse.ok || !applied) throw new Error('Matching-set discount was not applied');
      }
      if (checkout) { window.location.assign(root + 'checkout'); return; }
      window.location.assign(card.dataset.cartUrl);
    } catch {
      error.textContent = card.dataset.error;
      error.hidden = false;
      review.hidden = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
    } finally {
      states.forEach(s => {s.button.disabled = s.disabled; s.button.innerHTML = s.html; s.button.removeAttribute('aria-busy');});
      delete form.dataset.matchingBusy;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-action="add-to-cart"], [data-matching-buy]');
    const form = button?.closest('form');
    const card = form?.querySelector('[data-monzoro-matching]');
    if (card?.querySelector('[data-matching-toggle]').checked && !button.disabled) {
      event.preventDefault(); event.stopImmediatePropagation();
      addSet(form, card, button.hasAttribute('data-matching-buy'));
      return;
    }
    const quantityButton = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    const quantityCard = quantityButton?.closest('form')?.querySelector('[data-monzoro-matching]');
    if (quantityCard) queueMicrotask(() => update(quantityCard));
  }, true);
  document.addEventListener('submit', event => {
    const card = event.target.querySelector('[data-monzoro-matching]');
    if (!card?.querySelector('[data-matching-toggle]').checked) return;
    event.preventDefault(); event.stopImmediatePropagation(); addSet(event.target, card, false);
  }, true);
  document.addEventListener('change', event => {
    const card = event.target.closest('form')?.querySelector('[data-monzoro-matching]');
    if (card) update(card);
  });
  document.addEventListener('input', event => {
    if (event.target.name !== 'quantity') return;
    const card = event.target.closest('form')?.querySelector('[data-monzoro-matching]');
    if (card) update(card);
  });
  document.addEventListener('variant:changed', event => {
    const card = event.target.querySelector('[data-monzoro-matching]');
    if (!card || !event.detail.variant) return;
    card.dataset.primaryPrice = event.detail.variant.price;
    if (!event.detail.variant.available) card.querySelector('[data-matching-toggle]').checked = false;
    update(card);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


